export const cloneWith = <T extends object>(
  base: T,
  changes?: Partial<T> | undefined,
): T =>
  Object.assign(Object.create(base.constructor.prototype), {
    ...base,
    ...changes,
  });
